import React, { useState } from 'react';
import PropTypes from 'prop-types';

const AtomicItem = (props) => {
  const {
    block,
    contentState,
    blockProps: { getFileUrl },
  } = props;
  const [image, setImage] = useState(null);
  const entityKey = block.getEntityAt(0);
  if (!entityKey) {
    return null;
  }

  const entity = contentState.getEntity(entityKey);
  const type = entity.getType();
  const reader = new FileReader();
  reader.onload = (e) => {
    setImage(e.target.result);
  };

  if (!entity || type !== 'IMAGE') {
    return null;
  }

  const { name, file, fileId } = entity.getData();
  if (file && file.size > 0) {
    reader.readAsDataURL(file);
  }

  const currentFileId = file?.fileId || fileId;

  if (currentFileId && getFileUrl) {
    const url = getFileUrl(currentFileId);
    if (url) {
      return <img src={url} alt={name} className="editor-atomic-image" />;
    }
  }

  if (image) {
    return <img src={image} alt={name} className="editor-atomic-image" />;
  }
  return null;
};

export default AtomicItem;

AtomicItem.propTypes = {
  block: PropTypes.object,
  contentState: PropTypes.object,
  blockProps: PropTypes.object,
};
